import { ToolbarAction, ToolbarActions } from '../toolbar.actions';

export const rbdModalOpenReducer = function (
  sectionState: boolean = null,
  action: ToolbarAction<boolean>,
): boolean {
  switch (action.type) {
    case ToolbarActions.RBD_MODAL_TOGGLE: {
      return action.payload;
    }
    default:
      return sectionState;
  }
};
